module.exports = __webpack_public_path__ + "aeroland-startup-image-03.png?d641cadd1cb7fac685bdb03ff25eee97";